import Vue from 'vue'
import { isNull } from '@/utils'
Vue.filter('limiteStr', (str, count) => {
  if (isNull(str)) {
    return '-'
  } else if (str.length > count) {
    return str.slice(0, count) + '...'
  } else {
    return str
  }
})

Vue.filter('filterParams', (val) => {
  if (isNull(val)) {
    return '--'
  }
  return val
})

Vue.filter('formatMoney', (number) => {
  number = number || 0
  number = typeof number !== 'number' ? Number(number) : number
  number = isNaN(number) ? 0 : number
  var _thousand = ',',
    _decimal = '.'
  var negative = number < 0 ? '-' : '',
    i = parseInt((number = Math.abs(+number || 0).toFixed(2)), 10) + '',
    j = (j = i.length) > 3 ? j % 3 : 0
  return (
    negative +
    (j ? i.substr(0, j) + _thousand : '') +
    i.substr(j).replace(/(\d{3})(?=\d)/g, '$1' + _thousand) +
    _decimal +
    Math.abs(number - i)
      .toFixed(2)
      .slice(2)
  )
})
